<template>
  <div class="siginInDiv">
    <div class="siginIn">
      <!-- <div class="siginNum" v-if="blessingList != []">
        签到数：{{ siginNum }}
      </div>
      <div class="siginNum" v-else>
        签到数：0
      </div> -->
      <div class="siginInBtnDIv" @click="gotoBlessing" v-if="userIsSingin !== 1">
        <img src="../../assets/image/btn_qiandao_nor.png" alt="签到" class="siginInBtn" />
      </div>
      <div class="siginInBtnDIv" @click="gotoTakePhoto" v-if="userIsSingin == 1">
        <img src="../../assets/image/btn_qiandao_nor.png" alt="签到" class="siginInBtn" />
      </div>
      <div class="blessingDiv">
        <div class="blessingTitle">
          <img src="../../assets/image/btn_tou_nor.png" alt="祝福背景" class="blessingTitleImg" />
        </div>
        <div class="blessingTable">
          <vue-seamless-scroll :data="blessingList" class="seamless-warp">
            <div class="card" v-for="item in blessingList" :key="item.id">
              <div class="photoAndname clearfix">
                <div class="photoDiv">
                  <img :src="item.headimgurl" alt="头像" class="photo" />
                </div>
                <div class="name">{{ item.nickname }}</div>
                <div class="date" v-if="item.date">{{ item.date.substring(0, 10) }}</div>
              </div>
              <div class="blessing">{{ item.msg }}</div>
            </div>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      step: 0.15, // 数值越大速度滚动越快
      limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
      hoverStop: true, // 是否开启鼠标悬停stop
      direction: 1, // 0向下 1向上 2向左 3向右
      openWatch: true, // 开启数据实时监控刷新dom
      singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
      singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
      waitTime: 1000, // 单步运动停止的时间(默认值1000ms),
      userIsSingin: "",
      openid: '',
      blessingList: [],
      siginNum: ''
    };
  },
  created() {
    if (
      window.localStorage.getItem("siginOpenid") == "" ||
      window.localStorage.getItem("siginOpenid") == null
    ) {
      this.getCode();
    } else {
      this.getUserIsSingin();
    }
    this.getBlessingList();
  },
  methods: {
    getCode() {
      // 非静默授权，第一次有弹框
      var local = window.location.href; // 获取页面url
      //var local = "http://xyhall.alumni-resource.com/index.html"; // 获取页面url
      // TODO--START
      var appid = "wx56458d4baeea3d63";  // 校友汇公众号
      // var appid = "wxae254986265f7048";
     // TODO--END
           // wx8fb076fede2e6634 test可以用
      this.code = this.getUrlCode().code; // 截取code
      if (this.code == null || this.code === "") {
        // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      } else {
        this.getOpenIdApi();
      }
    },
    getUrlCode() {
      // 截取url中的code方法
      var url = location.search;
      this.winUrl = url;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    async getOpenIdApi() {
      const result = await this.$http({
        url: "/wx/wxcallback",
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: this.$qs.stringify({ code: this.code }),
      });
      this.openid = result.data.openId;
      window.localStorage.setItem("siginOpenid", this.openid);
      this.getUserIsSingin();
    },
    gotoBlessing() {
      return this.$router.push("/blessing");
    },
    gotoTakePhoto() {
      return this.$router.push("/takePhoto");
    },
    async getUserIsSingin() {
      const result = await this.$http.get(
        "/wx/issignin",
        {
          params: { openId: localStorage.getItem("siginOpenid") },
        }
      );
      this.userIsSingin = result.data.msg;
    },
    async getBlessingList() {
      const result = await this.$http.get(
        "/wx/getList"
      );
      this.blessingList = result.data.list;
      this.siginNum = this.blessingList.length;
    },
  },
};
</script>
<style lang="less" scoped>
.siginIn {
  position: relative;
  background-image: url(../../assets/image/btn_beijinga_nor.png);
  background-size: 100%, 100%;
  background-repeat: no-repeat, no-repeat;
  height: 160vh;
  width: 100%;

  .siginNum {
    position: absolute;
    left: 50%;
    top: 20%;
    transform: translate(-50%, -50%);
    font-weight: bold;
    color: #FFFFFF;
    font-size: 2rem;
  }

  .siginInBtnDIv {
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    width: 50%;

    .siginInBtn {
      width: 100%;
    }
  }

  .blessingDiv {
    width: 90%;
    position: absolute;
    left: 50%;
    top: 70%;
    transform: translate(-50%, -50%);

    .blessingTitleImg {
      width: 100%;
    }

    .blessingTable::-webkit-scrollbar {
      display: none;
    }

    .blessingTable {
      margin-top: -4px;
      width: 100%;
      background-color: white;
      height: 75vh;
      overflow: scroll;
      border-radius: 0 0 15px 15px;

      .card {
        margin-bottom: 15px;
        width: 90%;
        margin-left: 5%;
        background: #ffffff;
        border: 1px solid #b5b5b5;
        box-shadow: 0px 3px 5px 0px rgba(149, 149, 149, 0.44);
        border-radius: 10px;
        min-height: 21%;

        .photoAndname {
          position: relative;

          .photoDiv {
            float: left;
            margin: 10px 0 10px 10px;
            width: 10vw;
            height: 10vw;

            .photo {
              width: 100%;
              height: 100%;
              border-radius: 200px;
            }
          }

          .name {
            position: absolute;
            top: 50%;
            left: 18%;
            transform: translateY(-50%);
            float: left;
            font-weight: bold;
            color: #333333;
          }

          .date {
            font-weight: 400;
            color: #999999;
            position: absolute;
            top: 50%;
            right: 5px;
            transform: translateY(-50%);
            float: right;
            font-size: 0.9rem;
          }
        }

        .blessing {
          width: 96%;
          margin-left: 10px;
          margin-bottom: 10px;
          font-weight: 400;
          color: #666666;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          white-space: pre-line;
        }
      }
    }
  }
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/siginIn/SiginIn.vue